import { AgreementState } from '@/types/agreement_types';
import { AgreementSection } from '../common/AgreementSection';
import { EmailInput, EmailVerificationInput, NameInput, PasswordInput } from '../input/Inputs';

interface SignUpFormProps {
  formData: {
    email: string;
    password: string;
    passwordConfirm: string;
    name: string;
    verificationCode: string;
  };
  errors: Record<string, string>;
  onFieldChange: (field: string, value: string) => void;
  onAgreementChange: (allAgreed: boolean, state: AgreementState) => void;
  onSendVerificationCode: (isResend?: boolean) => Promise<boolean>;
  onVerifyCode: () => void;
  isEmailSent: boolean;
  isVerified: boolean;
  isSendingCode: boolean;
  isVerifyingCode: boolean;
  emailSuccessMessage?: string;
}

export const SignUpForm: React.FC<SignUpFormProps> = ({
  formData,
  errors,
  onFieldChange,
  onAgreementChange,
  onSendVerificationCode,
  onVerifyCode,
  isEmailSent,
  isVerified,
  isSendingCode,
  isVerifyingCode,
  emailSuccessMessage,
}) => (
  <>
    <EmailInput
      label="Email"
      value={formData.email}
      onChange={e => onFieldChange('email', e.target.value)}
      error={errors.email}
      successMessage={emailSuccessMessage}
      placeholder="Enter your email to receive a code"
      name="email"
      onSend={onSendVerificationCode}
      sendButtonText="Send"
      isSent={isEmailSent}
      isLoading={isSendingCode}
      disabled={isVerified}
    />

    <EmailVerificationInput
      label="Verification Code"
      value={formData.verificationCode}
      onChange={e => onFieldChange('verificationCode', e.target.value)}
      error={errors.verificationCode}
      placeholder="The code is valid for 10 minutes."
      name="verificationCode"
      onVerify={onVerifyCode}
      verifyButtonText="Verify"
      isLoading={isVerifyingCode}
      isVerified={isVerified}
      successMessage="Verification is complete."
      disabled={!isEmailSent}
    />

    <NameInput
      label="Name"
      value={formData.name}
      onChange={e => onFieldChange('name', e.target.value)}
      placeholder="Your Name"
      name="name"
      error={errors.name}
    />

    <PasswordInput
      label="Password"
      name="password"
      value={formData.password}
      onChange={e => onFieldChange('password', e.target.value)}
      error={errors.password}
      placeholder="********"
      helperText="Include uppercase, lowercase, number, and special character"
      autoComplete="new-password"
    />

    <PasswordInput
      label="Confirm Password"
      name="passwordConfirm"
      value={formData.passwordConfirm}
      onChange={e => onFieldChange('passwordConfirm', e.target.value)}
      error={errors.passwordConfirm}
      placeholder="********"
      helperText="Re-enter your password"
      autoComplete="new-password"
    />

    <AgreementSection onAgreementChange={onAgreementChange} context="signup" showAgeConfirmation={true} />
  </>
);
